module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Bold.fda61a2f.svg";